import React, { Suspense, useCallback } from 'react';
import PropTypes from 'prop-types';

import { BetManager, BetTypeProvider, useBetslipState } from '@atlas/core';
import { BetTypeSelector, Button, Icon, Label } from '@atlas/ui';

import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';

const MultipleControls = ({ selectedBet, setSelectedBetTypeIndex }) => {
  const { betTypes, loading } = useBetslipState();
  const { setIsOpenPopup } = useLocalBetslip();

  const removeAllBetItems = useCallback(() => {
    BetManager.clearBets();
    setIsOpenPopup(false);
  }, [setIsOpenPopup]);

  return (
    <div className="betslip-controls-multiple">
      <div className="betslip-controls-clear">
        <Button disabled={loading} loading={loading} onClick={removeAllBetItems} type="text">
          <Label message="clean_betslip" />
          <Icon height={20} name="trash-can" width={20} />
        </Button>
      </div>
      {selectedBet && (
        <Suspense fallback={<div />}>
          <BetTypeProvider betType={selectedBet} key={selectedBet.id}>
            <BetTypeSelector
              betTypes={betTypes}
              className="betslip-controls__selector"
              disabled={loading}
              selectedBet={selectedBet}
              setSelectedBetTypeIndex={setSelectedBetTypeIndex}
            />
          </BetTypeProvider>
        </Suspense>
      )}
    </div>
  );
};

MultipleControls.propTypes = {
  selectedBet: PropTypes.object.isRequired,
  setSelectedBetTypeIndex: PropTypes.func.isRequired,
};

export default MultipleControls;
